import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { EqualisationSettingsFormValues } from './FormWrapper';
import { Typography } from '@mui/material';
import { FieldRow } from 'components/FormElements';
import BasicSelect from 'further-ui/components/BasicSelect';
import useDayCountOptions from 'hooks/lp/data/vehicle/useDayCountOptions';

const OverallEqualisationInterestSettings: React.FC = () => {
  const { control } = useFormContext<EqualisationSettingsFormValues>();
  const dayCountOptions = useDayCountOptions();

  return (
    <>
      <Typography variant="h5">
        Overall equalisation interest settings
      </Typography>
      <FieldRow
        title="Day count"
        centerTitle
        tooltipText="This is the day count option used for calculating the equalisation interest across the fund vehicle."
      >
        <Controller
          name="dayCount"
          control={control}
          render={({ fieldState: { error }, field: { onChange, value } }) => (
            <BasicSelect
              fullWidth
              size="small"
              options={dayCountOptions}
              value={value}
              onChange={onChange}
              error={!!error}
            />
          )}
        />
      </FieldRow>
    </>
  );
};

export default OverallEqualisationInterestSettings;
